/* eslint-disable security/detect-object-injection */

import './LiveboardFilter.style.less'
import { Button, DatePicker, Divider, Radio, Row, Select, Space } from 'antd'
import { CloseOutlined, DownOutlined, FilterFilled } from '@ant-design/icons'
import { LBF_DATE_PICKER } from '../../Liveboard.constant'
import {
  filter as _filter,
  cloneDeep,
  find,
  flatten,
  get,
  isEmpty,
  map,
  omit,
} from 'lodash'
import { getDisplayValue, liveboardDateUtil } from '../../util/LiveboardUtil'
import { useEffect, useState } from 'react'

import LBCustomDropDown from '../LBCustomDropDown/LBCustomDropDown'
import { Moment } from 'moment'
import { Text } from '@/components/Typography'

const { getDisplay } = liveboardDateUtil

const { RangePicker } = DatePicker

// These filters send IDs to Metabase, so they always use options from their own endpoint
const ENDPOINT_OPTION_KEYS = [
  'country',
  'supplier',
  'factory',
  'inspector',
  'inspectionType',
]

interface Props {
  data?: any
  filters: any
  onChange?: (options: { filter: any; datePicked: Moment[] }) => any
}

import { MoreFiltersDropdown } from './MoreFiltersDropdown'

function LiveboardFilter({ data, onChange, filters }: Props) {
  const [filterConfig, setfilterConfig] = useState([])

  const [filter, setfilter] = useState<any>({})
  const [datePicked, setdatePicked] = useState<Moment[]>([])
  const [preset, setpreset] = useState<String>(null)
  const [showPreset, setshowPreset] = useState<boolean>(false)
  const [firstInit, setfirstInit] = useState(true)

  const _getCustomInputLabel = () => {
    if (!datePicked?.length || datePicked?.length < 2) return `Custom`
    const fromDate = get(datePicked, '[0]')
    const toDate = get(datePicked, '[1]')
    return `Custom (${getDisplay(fromDate)} to ${getDisplay(toDate)})`
  }

  const _clearFilter = () => {
    setfilter({})
  }

  const _removeItem = (item, key) => {
    const _keys = get(filter, key)
    const _item = _filter(_keys, (_key) => _key !== item)

    const itemLength = _item?.length ?? 0

    if (itemLength == 0) {
      let _newFilter = omit(cloneDeep(filter), key)
      setfilter(_newFilter)
      return
    }

    setfilter({
      ...filter,
      [key]: _item,
    })
  }

  const _onDateChange = (e) => {
    const _dateRange = find(
      LBF_DATE_PICKER,
      (item) => item.key === e.target.value
    )
    setdatePicked(get(_dateRange, 'date'))
  }

  const checkFilterValue = () => {
    const _filter = flatten(Object.keys(filter).map((key) => filter[key]))
    if (_filter.length < 1) _clearFilter()
  }

  const setMoreFilter = (item, checkedValues) => {
    const _filter = checkedValues.map((value) => {
      const _option = find(item.options, { key: value })
      return {
        key: value,
        label: getDisplayValue(_option, item.name),
        value: _option.value,
      }
    })
    setfilter({
      ...filter,
      [item.key]: _filter,
    })
  }

  useEffect(() => {
    if (!isEmpty(filter)) {
      checkFilterValue()
    }
  }, [filter])

  useEffect(() => {
    const _data = filters?.map((config) => {
      const settingOptions = config?.options
      const useSettingOptions =
        !ENDPOINT_OPTION_KEYS.includes(config?.key) &&
        Array.isArray(settingOptions) &&
        settingOptions.length > 0

      const options = useSettingOptions
        ? settingOptions.map((opt) => ({
            name: opt?.label || opt?.value,
            key: opt?.value,
          }))
        : get(
            find(data, (item) => item.key === config.key),
            'options',
            []
          )
      return {
        ...config,
        options: options,
      }
    })
    setfilterConfig(_data)
  }, [data, filters])

  useEffect(() => {
    setdatePicked(LBF_DATE_PICKER[3].date)
    setpreset(LBF_DATE_PICKER[3].key)
  }, [])

  useEffect(() => {
    if (firstInit && datePicked.length == 2) {
      onChange({ filter, datePicked })
      setfirstInit(false)
    }
  }, [filter, datePicked])

  useEffect(() => {
    setshowPreset(false)
  }, [datePicked])

  return (
    <div className="custom-filter-container">
      <Row justify="space-between" style={{ width: '100%' }}>
        <Row>
          {filterConfig?.map((item, index) => {
            if (index < 5) {
              return (
                // eslint-disable-next-line react/jsx-key
                <LBCustomDropDown
                  options={item.options.map((item: any) => {
                    return {
                      key: item?.key,
                      value: item?.name,
                    }
                  })}
                  onchange={(value) => {
                    setfilter({
                      ...filter,
                      [item.key]: value,
                    })
                  }}
                  value={item.key in filter ? filter[item.key] : []}
                  name={item.name}
                />
              )
            }
          })}

          {filterConfig?.length > 5 && (
            <MoreFiltersDropdown
              configs={filterConfig.slice(5)}
              filter={filter}
              setMoreFilter={setMoreFilter}
            />
          )}
        </Row>
        <Row>
          <div className="kk" onClick={() => setshowPreset(true)}>
            <Select
              className={'custom-date-selection-liveboard'}
              value={preset === 'custom' ? _getCustomInputLabel() : preset}
              onDropdownVisibleChange={() =>
                preset !== 'custom' ? setshowPreset(false) : () => {}
              }
              onChange={(e) => {
                setpreset(e)
                if (e !== 'custom') setshowPreset(false)
              }}
              onSelect={() => {
                setshowPreset(true)
              }}
              defaultValue={LBF_DATE_PICKER[3].key}
              open={showPreset}
              style={{ width: 300 }}
              placeholder="Select item ..."
              dropdownRender={() => (
                <>
                  <Radio.Group
                    name="radiogroup"
                    defaultValue={LBF_DATE_PICKER[3].key}
                    style={{ padding: '6px' }}
                    onChange={(e) => {
                      _onDateChange(e)
                      setpreset(e.target.value)
                      e.target.value !== 'custom' && setshowPreset(false)
                    }}
                  >
                    <Space direction="vertical">
                      {LBF_DATE_PICKER.map((item, key) => {
                        return (
                          <Radio
                            style={{ paddingLeft: '8px' }}
                            value={item.key}
                            key={key}
                            className="filter-preset"
                          >
                            {item.value}
                          </Radio>
                        )
                      })}
                    </Space>
                  </Radio.Group>
                  {preset === 'custom' && (
                    <>
                      <Divider style={{ margin: '8px 0' }} />
                      <RangePicker
                        style={{ margin: '5px 12px' }}
                        suffixIcon={<DownOutlined />}
                        className="date-picker"
                        size="small"
                        placement="topRight"
                        onChange={(v) => {
                          setdatePicked(v)
                          if (datePicked !== null) setshowPreset(false)
                        }}
                        separator={<p>-</p>}
                      />
                    </>
                  )}
                </>
              )}
              options={LBF_DATE_PICKER.map((item) => {
                return {
                  label: item.value,
                  value: item?.key,
                }
              })}
            />
          </div>
          <Button
            className="apply-button"
            type="primary"
            size={'large'}
            onClick={() => {
              onChange({ filter: filter, datePicked: datePicked })
            }}
          >
            Apply
          </Button>
        </Row>

        {Object.keys(filter).map((key) => key).length > 0 && (
          <div className={'site-button-ghost-wrapper-container'}>
            {Object.keys(filter)
              .map((key) => key)
              .map((key, index) => {
                if (!get(filter, key, [])?.length) return <></>
                return (
                  <div className="site-button-ghost-wrapper" key={index}>
                    <Text className="title">
                      {(
                        filterConfig.find((item) => item.key === key)?.name ||
                        key
                      ).toUpperCase()}
                    </Text>
                    {map(get(filter, key), (item) => {
                      return (
                        <>
                          <Text className="item">
                            {getDisplayValue(
                              item,
                              filterConfig.find((item) => item.key === key)
                                ?.name || key
                            )}
                          </Text>
                          <Button
                            type="ghost"
                            className="item-icon"
                            shape="circle"
                            size="small"
                            onClick={() => {
                              _removeItem(item, key)
                            }}
                            icon={<CloseOutlined />}
                          />
                        </>
                      )
                    })}
                  </div>
                )
              })}

            <Button
              type="ghost"
              icon={<CloseOutlined />}
              size="large"
              className="clear-filter"
              onClick={() => {
                _clearFilter()
              }}
            >
              Clear Filters
            </Button>
          </div>
        )}
      </Row>
    </div>
  )
}
export default LiveboardFilter
